import { observer } from 'mobx-react-lite';
import { Modal, ModalProps } from './modal';
import { useTranslationsContext } from 'store/translations';
import { Button } from 'components/core';
import FullCollection from 'assets/img/full_collection.png';
import Ticket from 'assets/img/ticket_bg.png';

import './helpModal.styl';
import { useEffect } from 'react';
import { useStoreContext } from 'store/app';
import { ShortLinkSubType, ShortLinkType } from 'src/types';

interface HelpModalProps extends ModalProps {}

export const HelpModal = observer((props: HelpModalProps) => {
    const { translate } = useTranslationsContext();
    const { logOperation, openLink, linkToRules } = useStoreContext();

    useEffect(() => {
        logOperation('help', 'render');
    }, []);

    const onAgreementClick = () => {
        logOperation('help', 'agreement');
        openLink(linkToRules, true, { type: ShortLinkType.TAB, subtype: ShortLinkSubType.HELP });
    };

    return (
        <Modal title={translate('help.title')} {...props}>
            <div className="help-modal">
                <div className="help-modal-heading">{translate('help.heading')}</div>
                <div className="help-modal-subheading">{translate('help.subheading')}</div>
                <div className="help-modal-card help-modal-card-toy">
                    <img className="help-modal-card-image" src={FullCollection} />
                    <span className="help-modal-card-text">{translate('help.card.toys')}</span>
                </div>
                <div className="help-modal-card help-modal-card-ticket">
                    <img className="help-modal-card-image" src={Ticket} />
                    <span className="help-modal-card-text">{translate('help.card.ticket')}</span>
                </div>
                <Button className="help-modal-button" onClick={onAgreementClick}>
                    {translate('agreement.read')}
                </Button>
            </div>
        </Modal>
    );
});
